module.exports = __webpack_public_path__ + "img/vpnbook-nokia-3.b4951127.png";